export default __webpack_public_path__ + "static/media/categoryPot.9ef1b587.jpg";